import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DxTextBoxModule } from 'devextreme-angular';
import { BehaviorSubject, Subject } from 'rxjs';

@Component({
	selector: 'delete-link-modal',
	standalone: true,
	imports: [
		CommonModule,
		DxTextBoxModule,
		FormsModule, ReactiveFormsModule
	],
	templateUrl: './delete-link-modal.component.html',
	styleUrl: './delete-link-modal.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteLinkModalComponent implements OnInit {
	constructor() {

	}

	ngOnInit() {
		setInterval(() => this.deleteDisableCounter$.next(Math.max(0, this.deleteDisableCounter$.value - 1)), 1000);
	}

	public showDialog$: Subject<boolean> = new BehaviorSubject<boolean>(false);

	public confirmDelete$: Subject<void> = new Subject<void>();

	public deleteDisableCounter$: BehaviorSubject<number> = new BehaviorSubject<number>(0);

	public showAndAwait() {
		this.deleteDisableCounter$.next(10);
		this.showDialog$.next(true);
		return this.confirmDelete$;
	}

	public cancel(): void {
		this.showDialog$.next(false);
	}

	public confirm(): void {
		this.showDialog$.next(false);
		this.confirmDelete$.next();
	}
}
